module.exports = __webpack_public_path__ + "img/prize81.bca34492.png";